import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Text = styled.p`
  margin-left: 16px;
  font-size: 14px;
  line-height: 16.8px;
`
